import React from "react";
import { Box, Grid, TextField, Button, Typography } from "@mui/material";

export default function Contact() {
  return (
    <Box
      component="section"
      id="contact"
      sx={{
        backgroundColor: "#F7FAFF",
        py: { xs: 6, md: 10 },
        fontFamily: "Roboto, sans-serif",
      }}
    >
      {/* FIXED WIDTH CONTAINER */}
      <Box
        sx={{
          px: { xs: 2, sm: 4, md: "250px" },
        }}
      >
        {/* HEADING */}
        <Box sx={{ textAlign: "center", mb: 6 }}>
          <Typography
            component="h1"
            sx={{
              fontSize: "32px",
              fontWeight: 700,
              color: "#2d2075",
              mb: 1,
            }}
          >
            Contact Us
          </Typography>

          <Box
            sx={{
              width: 90,
              height: "3px",
              backgroundColor: "#2d2075",
              mx: "auto",
            }}
          />
        </Box>

        {/* WHITE CARD */}
        <Box
          sx={{
            backgroundColor: "#ffffff",
            borderRadius: "2px",
            p: { xs: 3, sm: 4, md: 5 },
            boxShadow: "0 8px 28px rgba(0,0,0,0.10)",
          }}
        >
          <Grid container spacing={{ xs: 4, md: 6 }} alignItems="flex-start">
            
            {/* LEFT : FORM */}
            <Grid item xs={12} md={6}>
              <Typography
                sx={{
                  mb: 3,
                  color: "#06224A",
                  fontSize: "20px",
                }}
              >
                Please use the form below or contact us directly for any enquiries.
              </Typography>

              <TextField fullWidth label="Full Name *" variant="standard" sx={{ mb: 3 }} />
              <TextField fullWidth label="Email *" variant="standard" sx={{ mb: 3 }} />
              <TextField fullWidth label="Company Name" variant="standard" sx={{ mb: 3 }} />
              <TextField fullWidth label="Phone Number *" variant="standard" sx={{ mb: 3 }} />
              <TextField
                fullWidth
                label="Message"
                variant="standard"
                multiline
                rows={4}
                sx={{ mb: 4 }}
              />

              <Button
                variant="contained"
                sx={{
                  backgroundColor: "#2d2075",
                  px: 5,
                  py: 1.2,
                  borderRadius: "2px",
                  fontSize: "16px",
                  fontWeight: 600,
                  textTransform: "none",
                  "&:hover": { backgroundColor: "#2d2075" },
                }}
              >
                Submit
              </Button>
            </Grid>

            {/* RIGHT : CONTACT INFO + GOOGLE MAP */}
            <Grid item xs={12} md={6}>
              <Box sx={{ pl: { xs: 0, md: 6 } }}>
                <Typography
                  component="h2"
                  sx={{
                    fontSize: "24px",
                    fontWeight: 700,
                    mb: 2,
                    color: "#2d2075",
                  }}
                >
                  Contact Information
                </Typography>

                <Typography
                  sx={{
                    fontSize: "20px",
                    color: "#333",
                    lineHeight: 1.6,
                  }}
                >
                  <strong>Corporate Office:</strong>
                  <br />
                  Multitex Filters Private Limited
                  <br />
                  A-134, Sector 136
                  <br />
                  Noida, Uttar Pradesh – 201304
                  <br /><br />
                  <strong>Email:</strong>
                  <br />
                  spares@multitex.co.in
                  <br />
                  enquiry@multitex.co.in
                </Typography>

                {/* GOOGLE MAP (YOUR EXACT LOCATION) */}
                <Box
                  sx={{
                    mt: 4,
                    width: "100%",
                    height: { xs: 250, md: 300 },
                    borderRadius: "4px",
                    overflow: "hidden",
                    boxShadow: "0 6px 20px rgba(0,0,0,0.15)",
                  }}
                >
                  <iframe
                    title="Office - Multitex Filters Private Limited"
                    src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3503.529542509514!2d77.3989672!3d28.5038986!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x390ce9cebfdd6127%3A0x9e9d959d7662af70!2sOffice-Multitex%20Filtration%20Engineers%20Ltd.!5e0!3m2!1sen!2sin!4v1733740000000"
                    width="100%"
                    height="100%"
                    style={{ border: 0 }}
                    loading="lazy"
                    referrerPolicy="no-referrer-when-downgrade"
                  />
                </Box>
              </Box>
            </Grid>

          </Grid>
        </Box>
      </Box>
    </Box>
  );
}
